"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_KNOWN_ROLES = exports.KnownRoles = exports.CIP_ISSUERS = exports.JWT_ISSUER = exports.JWT_VERSION = void 0;
exports.isKnownRole = isKnownRole;
exports.isTBWJwt = isTBWJwt;
exports.isServiceJwt = isServiceJwt;
exports.isClientJwt = isClientJwt;
exports.isCIPJwt = isCIPJwt;
exports.JWT_VERSION = '1.0';
exports.JWT_ISSUER = 'tocalife-server';
exports.CIP_ISSUERS = ['cip-dev', 'cip-staging', 'cip-prod'];
var KnownRoles;
(function (KnownRoles) {
    KnownRoles["admin"] = "admin";
    KnownRoles["backendService"] = "backend-service";
    KnownRoles["analytics"] = "analytics";
    // TODO: add all roles for CMS based on google groups?
})(KnownRoles || (exports.KnownRoles = KnownRoles = {}));
function isKnownRole(role) {
    return Object.values(KnownRoles).includes(role);
}
exports.ALL_KNOWN_ROLES = Object.values(KnownRoles);
function isTBWJwt(jwt) {
    return (jwt !== null &&
        typeof jwt === 'object' &&
        'iss' in jwt &&
        typeof jwt.iss === 'string' &&
        'iat' in jwt &&
        typeof jwt.iat === 'number');
}
function isServiceJwt(jwt) {
    return (jwt !== null &&
        typeof jwt === 'object' &&
        'exp' in jwt &&
        typeof jwt.exp === 'number' &&
        'roles' in jwt &&
        Array.isArray(jwt.roles) &&
        'version' in jwt &&
        typeof jwt.version === 'string');
}
function isClientJwt(jwt) {
    return (jwt !== null &&
        typeof jwt === 'object' &&
        'accountId' in jwt &&
        typeof jwt.accountId === 'string' &&
        'profileId' in jwt &&
        typeof jwt.profileId === 'string' &&
        'version' in jwt &&
        typeof jwt.version === 'string');
}
function isCIPJwt(jwt) {
    return (jwt !== null &&
        typeof jwt === 'object' &&
        'sub' in jwt &&
        typeof jwt.sub === 'string' &&
        'typ' in jwt &&
        jwt.typ === 'access' &&
        'exp' in jwt &&
        typeof jwt.exp === 'number' &&
        'aud' in jwt &&
        jwt.aud === 'World');
}
